import { lazy } from 'react'

import { RouteConfig } from 'packages/route'

/**
 * 获取路由
 *
 * @returns 路由定义
 */
export const getRoutes: () => RouteConfig[] = () => [
  {
    path: 'task/course/:taskMsg',
    getTitle: () => '课程',
    name: 'UserCourseTask',
    component: lazy(() =>
      import('./pages/UserCourse').then((m) => ({
        default: m.UserCourse,
      }))
    ),
  },
]
